



import Image from '@/components/common/Image'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class PartsGallery extends Vue {
  @Prop({ required: true }) gallery!: Image[]
}
